/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelServizioMensaRendicontazioneReportRowDTO } from '../model/models';
import { PagedModelServizioMensaRicaricaReportRowDTO } from '../model/models';
import { ServizioMensaRendicontazioniListFilter } from '../model/models';
import { ServizioMensaRicaricheListFilter } from '../model/models';
import { ServizioMensaRicaricheStatisticheDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface GetServizioMensaPagamentiReportRendicontazioniRequestParams {
    filter: ServizioMensaRendicontazioniListFilter;
    pageable: Pageable;
    gestioneMenseServizioId: string;
}

export interface GetServizioMensaPagamentiReportRicaricheRequestParams {
    filter: ServizioMensaRicaricheListFilter;
    pageable: Pageable;
    gestioneMenseServizioId: string;
}

export interface GetServizioMensaPagamentiReportStatisticheRequestParams {
    anno: number;
    gestioneMenseServizioId: string;
    filtraPerDataPagamento?: boolean;
}


export interface ServizioMensaReportisticaPagamentiServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Report paginato delle rendicontazioni del servizio.
     * Lista paginata di righe {rendicontazione, intestazione} del servizio risolto dall\&#39;header Gestione-Mense-Servizio-Id, incluse le disabilitate (flag disabilitata in riga). Filtri: numero_mese, nominativo (match ESATTO su studente o genitore). Sort default meseRendicontazione ASC, size default illimitato. Gated su tipoPagamento ∈ {PAGO_PA_RENDICONTAZIONE, PAGO_PA_RENDICONTAZIONE_E_RICARICHE} → 400 servizio_mensa_rendicontazioni_tipo_pagamento_non_abilitato. Audience backoffice (OP_COMUNE/ADMIN/SUPERADMIN).
     * @endpoint get /api/v1/servizi/mensa/rendicontazioni
* @param requestParameters
     */
    getServizioMensaPagamentiReportRendicontazioni(requestParameters: GetServizioMensaPagamentiReportRendicontazioniRequestParams, extraHttpRequestParams?: any): Observable<PagedModelServizioMensaRendicontazioneReportRowDTO>;

    /**
     * Report paginato delle ricariche del servizio.
     * Lista paginata di righe {ricarica, intestazione} del servizio risolto dall\&#39;header Gestione-Mense-Servizio-Id. Filtri: data_da/data_a (range date), stato_interno, nominativo (match ESATTO su studente o genitore — cambio contratto FE vs il LIKE legacy), filtra_per_data_pagamento (override; se assente la colonna-data deriva da tipoPagamento&#x3D;&#x3D;MANUALE). Sort default dataPagamento DESC, size default illimitato. Audience backoffice (OP_COMUNE/ADMIN/SUPERADMIN).
     * @endpoint get /api/v1/servizi/mensa/ricariche
* @param requestParameters
     */
    getServizioMensaPagamentiReportRicariche(requestParameters: GetServizioMensaPagamentiReportRicaricheRequestParams, extraHttpRequestParams?: any): Observable<PagedModelServizioMensaRicaricaReportRowDTO>;

    /**
     * Statistiche ricariche per anno solare.
     * 12 bucket mensili {numero_mese, anno, totale_ricariche, totale_pagato, totale_in_attesa_pagamento} dell\&#39;anno solare richiesto (mesi senza ricariche → 0.0) + blocco totale &#x3D; somma dei bucket. Il parametro anno è OBBLIGATORIO (400 se assente). La colonna-data segue la stessa risoluzione della lista (filtra_per_data_pagamento o tipoPagamento&#x3D;&#x3D;MANUALE). Audience backoffice (OP_COMUNE/ADMIN/SUPERADMIN).
     * @endpoint get /api/v1/servizi/mensa/ricariche/statistiche
* @param requestParameters
     */
    getServizioMensaPagamentiReportStatistiche(requestParameters: GetServizioMensaPagamentiReportStatisticheRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaRicaricheStatisticheDTO>;

}
